import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-tmams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-tmams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationDetailsTmamsConstants } from "./create-application-details-tmams.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationDetailsTmamsComponent = class CreateApplicationDetailsTmamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    searchApplicationsService;
    applicationTypeCtrl = CreateApplicationDetailsTmamsConstants.TYPE_CTRL;
    applicationTypeLbl = CreateApplicationDetailsTmamsConstants.TYPE_LBL;
    descriptionCtrl = CreateApplicationDetailsTmamsConstants.DESCRIPTION_CTRL;
    descriptionLbl = CreateApplicationDetailsTmamsConstants.DESCRIPTION_LBL;
    validationMessages = CreateApplicationDetailsTmamsConstants.VALIDATION_MESSAGES;
    applicationTypePlaceHolder = CreateApplicationDetailsTmamsConstants.APPLICATION_PLACE_HOLDER;
    applicationTypes = [];
    detailsForm;
    title = "";
    selectedApplicationDetailsTmamsSubscription;
    getLookupsObservableSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.loadLookup();
        this.getMetadata();
        this.subscribeToSelectedApplication();
    }
    loadMetadata(stepMeta) {
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationDetailsTmamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm.enable();
    }
    populateForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.markAsTouched();
        else
            return;
        this.detailsForm.get(this.applicationTypeCtrl).setValue(application.type);
        this.detailsForm.get(this.descriptionCtrl).setValue(application.description);
    }
    loadLookup() {
        this.getLookupsObservableSubscription = this.applicationCreateService.getLookupsObservable({ $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'ApplicationType' and deleted eq false` }).subscribe(lookupValues => {
            const lookup = lookupValues.value;
            lookup.forEach(lp => {
                this.applicationTypes.push(JSON.parse(lp.content));
            });
            this.applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
            this.changeDetectorRefs.detectChanges();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsTmamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-tmams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsTmamsComponent);
export { CreateApplicationDetailsTmamsComponent };
